export default {"src":"/_next/static/media/mobile-cart.bc3432b8.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};